class JwtError extends Error {}

class MissingTokenError extends JwtError {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, new.target.prototype);

    this.name = "MissingTokenError";
  }
}

class InvalidTokenError extends JwtError {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, new.target.prototype);

    this.name = "InvalidTokenError";
  }
}

class ExpiredTokenError extends JwtError {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, new.target.prototype);

    this.name = "ExpiredTokenError";
  }
}

class InvalidUserError extends JwtError {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, new.target.prototype);

    this.name = "InvalidUserError";
  }
}

class InvalidIssuerError extends JwtError {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, new.target.prototype);

    this.name = "InvalidIssuerError";
  }
}

export {
  MissingTokenError,
  ExpiredTokenError,
  InvalidUserError,
  InvalidTokenError,
  InvalidIssuerError,
};